import React, { forwardRef } from 'react';
import _ from 'lodash';
import { Input } from '@kufox/mui';

function InputEye(props = {}, ref) {
  const { iconStyle, onChange = _.noop, ...others } = props;

  const InputChange = (e) => {
    onChange(e.target.value);
  };

  return <Input {...others} ref={ref} onChange={InputChange} />;
}

export default forwardRef(InputEye);
